export const SET_SKIN = 'settings/SET_SKIN';
export const SET_VIEW_AS = 'settings/SET_VIEW_AS';
export const SET_LOCATION = 'settings/SET_LOCATION';